<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="[
        'Período Movimento',
        'Descrição',
        'Nível Risco',
        'Nível Risco Desc.',
        'Modalidade Bacen',
        'Sub Modal. Bacen',
        'Val. Vencer 30',
        'Val. Vencer 360',
        'Val. Vencer Total',
        'Val. Coobrigacao',
        'Val. Prejuízo',
        'Val. Devedor',
        'Val. Vencido 90',
        'Val. Vencido Total'
        ]"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.periodoMovimento ? formatPeriod(obj.periodoMovimento) : ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.nome" />
        <TableColumn :IsText="true" :status="1" :value="obj.nivelRisco" />
        <TableColumn :IsText="true" :status="1" :value="obj.nivelRiscoDescricao" />
        <TableColumn :IsText="true" :status="1" :value="obj.modalidadeBacen" />
        <TableColumn :IsText="true" :status="1" :value="obj.subModalidadeBacen" />
        <TableColumn :IsText="true" :status="1" :value="obj.valSFNVencer30 ? formatValue(obj.valSFNVencer30) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valSFNVencer360 ? formatValue(obj.valSFNVencer360) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valSFNVencerTotal ? formatValue(obj.valSFNVencerTotal) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valSFNCoobrigacao ? formatValue(obj.valSFNCoobrigacao) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valSFNPrejuizo ? formatValue(obj.valSFNPrejuizo) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valSFNSaldoDevedor ? formatValue(obj.valSFNSaldoDevedor) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valSFNVencido90 ? formatValue(obj.valSFNVencido90) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valSFNVencido ? formatValue(obj.valSFNVencido) : 'R$ 0,00'" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import IndebtednessRepository from '@/shared/http/repositories/business/indebtedness.js'

export default {
  name: 'Indebtedness',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadIndebtedness(this.document)
      }
    },
    onLoadIndebtedness (document) {
      loading.push()
      this.document = document
      IndebtednessRepository.SearchSFN(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    formatPeriod (value) {
      let result
      if (value) {
        result = value.substring(5, 7) + '/' + value.substring(0, 4)
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/IndebtednessSFN.vue